<!--
 * @Author: tony.zhu
 * @Date: 2025-09-26 10:58:35
 * @LastEditTime: 2025-12-04 11:11:34
 * @LastEditors: tony.zhu
 * @Description: 
-->

<template>
  <div class="c-answer">
    <div class="answer_wrap">
      <div class="answer_wrap__right_wrap">
        <Loading v-if="data.loading"></Loading>
        <div class="content_wrap" :data-streaming="data.streaming ? 'true' : null" v-if="data.content.length" style="position: relative;">
          <!-- 内容渲染 -->
          <!-- 插槽类型渲染 -->
          <div v-for="(u, o) in data.content" :key="o" class="content_wrap__item">
            <template v-if="$attrs.isShowOperate !== undefined ? $attrs.isShowOperate : false">
              <div v-html="u.value || ''" style="white-space: pre-line; word-break: break-all"></div>
            </template>
            <template v-else>
              <MarkdownPlus
                v-if="u.type == answerContentTypeEnum.Object.TEXT.code && u.value"
                class="md_body"
                :id="u.id"
                :content="u.value || ''"
              />
              <template v-else>
                <template v-for="(e, i) in answerContentTypeEnum.Array">
                  <slot
                    v-if="e.code !== answerContentTypeEnum.Object.TEXT.code"
                    :name="e.code + o"
                    :data="{ contentTypeData: e, params: data }"
                  />
                </template>
              </template>
            </template>
          </div>
        </div>

        <!-- 知识文档文件列表 -->
        <div class="knowledge-files" v-if="formModalDataProp.answer && formModalDataProp.answer.knowledgeDocument && formModalDataProp.answer.knowledgeDocument.length">
          <div class="knowledge-files__item" v-for="(file, idx) in formModalDataProp.answer.knowledgeDocument" :key="idx">
            <span class="knowledge-files__link" @click.prevent="handleFilePreview(file)">
              {{ file.fileName }}
            </span>
          </div>
        </div>
        <template v-if="data.chatAiResult == 'error'">
          <div class="error_wrap">可能会导致报错或出现异常搜索结果</div>
        </template>
        <!-- 思考中或流式返回期间操作按钮禁用，流式结束后恢复正常 -->
        <div class="operate_wrap">
          <ActionsItem
            :dataProp.sync="data"
            :indexProp="index"
            v-if="($attrs.isShowOperate !== undefined ? $attrs.isShowOperate : true) && (data.content.length || data.streaming || data.loading)"
            :formModalDataProp="formModalDataProp"
            :isDisabled="data.streaming || data.loading || $store.state.aiChat.textareaIsDisabled"
            v-bind="$attrs"
            v-on="$listeners"
          ></ActionsItem>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionsItem from './actionsItem.vue'
import Loading from './loading.vue'
import MarkdownPlus from '../markdownIt/index.vue'
import { ANSWER_CONTENT_TYPE_ENUM } from '@/components/aiChat/common/notification.js'
import { changeMappingHandle } from '@/components/aiChat/utils/tbox.js'

export default {
  components: {
    ActionsItem,
    Loading,
    MarkdownPlus
  },
  props: {
    dataProp: {
      type: Object,
      default() {
        return {}
      }
    },
    formModalDataProp: {
      type: Object,
      default() {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    answerContentTypeEnum() {
      return changeMappingHandle(ANSWER_CONTENT_TYPE_ENUM)
    }
  },
  data() {
    return {
      data: {}
    }
  },
  watch: {
    dataProp: {
      handler: function (n) {
        this.data = JSON.parse(JSON.stringify({ ...n }))
        console.log(this.data, 'this.data')
        if (this.data.content && this.data.content.length > 0) {
          this.data.content[0].value = this.replaceImageUrl(this.data.content[0].value)
        }
      },
      immediate: true
    },
    data: {
      handler: function (n) {
        this.$emit('on-change-data', {
          ...this.dataProp,
          ...n
        })
      },
      deep: true
    }
  },
  methods: {
    replaceImageUrl(markdownContent) {
      // 正则表达式匹配 Markdown 图片语法
      const imageRegex = /!\[.*?\]\((.*?)\)/g
      const urlRegex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/
      const exampleComRegex = /^https:\/\/example\.com\/.*$/
      // 检测图片地址
      let newMarkdownContent = markdownContent.replace(imageRegex, (match, p1) => {
        if (!urlRegex.test(p1)) {
          // 不是图片链接
          return ''
        } else if (exampleComRegex.test(p1)) {
          // 是example.com链接
          return ''
        }
        return match
      })
      return newMarkdownContent
    },
    handleFilePreview(file) {
      try {
        this.$bus.emit('open-file-preview', {
          url: file.fileUrl,
          name: file.fileName
        })
      } catch (error) {
        this.$bus.$emit('open-file-preview', {
          url: file.fileUrl,
          name: file.fileName
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.c-answer {
  .answer_wrap {
    display: flex;
    align-items: center;
    align-items: flex-start;
    &__left_wrap {
      margin-right: 16px;
      .icon {
        width: 36px !important;
        height: 36px !important;
        background-color: #fff;
        border-radius: 20px;
        ::v-deep .el-image__inner {
          border-radius: 20px;
        }
      }
    }
    &__right_wrap {
      // margin-right: 52px;
      overflow: hidden;
      .info_wrap {
        display: flex;
        align-items: center;
        margin-bottom: 4px;
        // min-width: 180px;
        div {
          font-size: 14px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          line-height: 20px;
          font-size: 14px;
          line-height: 22px;

          &.name {
            color: #1d2129;
            margin-right: 12px;
          }
          &.time {
            font-size: 12px;
            color: #86909c;
            display: none;
          }
        }
      }
      .content_wrap {
        border-radius: 0px 16px 16px 16px;
        background: #fff;
        padding: 12px 15px;
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        line-height: 20px;
        font-size: 14px;
        color: #4e5969;
        line-height: 22px;
        display: inline-block;
        overflow: hidden;
        // width: calc(100% - 24px);
        &__item {
          margin-bottom: 16px;
          &:last-child {
            margin-bottom: 0;
          }
        }
        .md_body {
          ::v-deep {
            .markdown-body {
              font-size: 14px;
              color: #4e5969;
              // white-space: pre-line;
              white-space: normal;
              pre {
                padding: 0;
                background-color: transparent;
                code {
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 400;
                  font-size: 14px;
                  color: #4e5969;
                  line-height: 22px;
                  word-break: break-word;
                  width: 100%;
                  display: block;
                  white-space: pre-line;
                }
              }
              p {
                white-space: pre-line;
                margin: 4px 0;
              }
              ul,
              li,
              ol {
                list-style-type: none;
                white-space: normal;
              }
              > ol,
              > ul {
                white-space: normal;
              }

              .octicon-link {
                display: none;
              }
              .hljs {
                padding: 8px 24px 24px;
                margin: 12px 0;
                background: linear-gradient(to bottom, #343541 40px, #0d1117 40px);
                &[issetdiv] {
                  padding-top: 8px;
                }
                &:not([issetdiv]) {
                  padding-top: 52px;
                }
                border-radius: 8px;
              }
            }
          }
        }
      }

      .error_wrap {
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        line-height: 20px;
        font-size: 12px;
        color: #ff3c38;
        line-height: 16px;
        margin-top: 4px;
        margin-left: 12px;
      }
      .operate_wrap {
        margin-top: 4px;
        margin-left: 16px;
        min-height: 24px;
        z-index: 2;
        position: relative;
        ::v-deep .c-operate {
          opacity: 0;
          transition: opacity 0.3s;
        }
      }
      &:hover {
        ::v-deep .c-operate {
          opacity: 1;
          transition: opacity 0.3s;
        }
        .info_wrap {
          .time {
            display: block;
          }
        }
      }
    .knowledge-files {
        margin-top: 12px;
        margin-left: 16px;
        &__item {
          display: flex;
          align-items: center;
          padding: 6px 12px;
          font-size: 13px;
          line-height: 20px;
          border-radius: 6px;
          background: #f2f3f5;
          margin-bottom: 6px;
          &:last-child {
            margin-bottom: 0;
          }
          a {
            color: #165dff;
            text-decoration: none;
            &:hover {
              text-decoration: underline;
            }
          }
          .knowledge-files__link {
            color: #165dff;
            cursor: pointer;
            text-decoration: none;
            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
@keyframes streaming-dot-pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.4;
    transform: scale(0.75);
  }
}

@keyframes streaming-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.c-answer .answer_wrap .answer_wrap__right_wrap .content_wrap{
  .thinkText{
    display: none;
  }
}

.c-answer .answer_wrap .answer_wrap__right_wrap .c-loading .loading_box_wrap {
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background: linear-gradient(
      110deg,
      transparent 25%,
      rgba(22, 93, 255, 0.06) 37%,
      rgba(22, 93, 255, 0.12) 50%,
      rgba(22, 93, 255, 0.06) 63%,
      transparent 75%
    );
    background-size: 200% 100%;
    animation: streaming-shimmer 2.5s ease-in-out infinite;
    pointer-events: none;
  }

  &::after {
    content: '';
    position: absolute;
    top: 8px;
    right: 12px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #165dff;
    box-shadow: 0 0 6px 2px rgba(22, 93, 255, 0.35);
    animation: streaming-dot-pulse 1.2s ease-in-out infinite;
    pointer-events: none;
    z-index: 1;
  }

  > * {
    position: relative;
    z-index: 1;
  }
}

.c-answer .answer_wrap .answer_wrap__right_wrap .content_wrap[data-streaming="true"] {
  overflow: hidden;

  > * {
    position: relative;
    z-index: 1;
  }

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background: linear-gradient(
      110deg,
      transparent 25%,
      rgba(22, 93, 255, 0.06) 37%,
      rgba(22, 93, 255, 0.12) 50%,
      rgba(22, 93, 255, 0.06) 63%,
      transparent 75%
    );
    background-size: 200% 100%;
    animation: streaming-shimmer 2.5s ease-in-out infinite;
    pointer-events: none;
  }

  &::after {
    content: '';
    position: absolute;
    top: 5px;
    right: 5px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #165dff;
    box-shadow: 0 0 6px 2px rgba(22, 93, 255, 0.35);
    animation: streaming-dot-pulse 1.2s ease-in-out infinite;
    pointer-events: none;
    z-index: 2;
  }
  .thinkText{
    display: block !important;
  }
}
</style>
